import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Trophy as Whistle, Football as SoccerBall } from "@phosphor-icons/react";

import { useNavigate } from "react-router-dom";
export default function Login() {
    const { login, user } = useAuth();
    const { settings } = useSettings();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    useEffect(() => {
        if (user) nav("/", { replace: true });
    }, [user, nav]);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        const r = await login(email.trim(), password);
        setLoading(false);
        if (!r.ok) setErr(r.error);
        else nav("/", { replace: true });
    };

    const demo = (em, pw) => {
        setEmail(em);
        setPassword(pw);
    };

    return (
        <div className="min-h-dvh grid md:grid-cols-2 bg-background">
            {/* Left hero */}
            <div className="hidden md:flex relative overflow-hidden bg-card border-r border-border/60">
                <img
                    src="https://images.pexels.com/photos/28827841/pexels-photo-28827841.jpeg"
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover opacity-40"
                />
                <div className="absolute inset-0 bg-gradient-to-br from-background via-background/60 to-transparent" />
                <div className="relative z-10 flex flex-col justify-between p-10 w-full">
                    <div className="flex items-center gap-3">
                        <div className="w-11 h-11 rounded-xl grid place-items-center bg-primary/20 text-primary hairline">
                            <Whistle size={24} weight="fill" />
                        </div>
                        <div>
                            <div className="font-display text-xl font-bold tracking-tight uppercase">
                                {settings?.club_name || "Calcio Club"}
                            </div>
                            <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
                                Gestione società
                            </div>
                        </div>
                    </div>
                    <div>
                        <h1 className="font-display text-5xl lg:text-6xl font-black uppercase leading-[0.9] tracking-tighter">
                            La tua<br />
                            <span className="text-primary">squadra.</span><br />
                            Sempre con te.
                        </h1>
                        <p className="text-muted-foreground mt-6 max-w-md leading-relaxed">
                            Partite, convocazioni, materiale da portare, news e comunicazioni.
                            Tutto in un&apos;unica app installabile su iPhone e Android.
                        </p>
                    </div>
                    <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
                        Stagione 2025 / 2026
                    </div>
                </div>
            </div>

            {/* Right form */}
            <div className="flex items-center justify-center px-5 py-10">
                <div className="w-full max-w-sm">
                    <div className="md:hidden flex items-center gap-3 mb-8">
                        <div className="w-11 h-11 rounded-xl grid place-items-center bg-primary/20 text-primary hairline">
                            <Whistle size={24} weight="fill" />
                        </div>
                        <div>
                            <div className="font-display text-xl font-bold tracking-tight uppercase">
                                {settings?.club_name || "Calcio Club"}
                            </div>
                            <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
                                Gestione società
                            </div>
                        </div>
                    </div>
                    <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
                        Bentornato
                    </div>
                    <h2 className="font-display text-3xl md:text-4xl font-black uppercase tracking-tight mt-1">
                        Accedi al tuo account
                    </h2>
                    <form onSubmit={submit} className="mt-8 space-y-4">
                        <div className="space-y-2">
                            <Label htmlFor="email" className="text-xs uppercase tracking-widest text-muted-foreground">
                                Email
                            </Label>
                            <Input
                                id="email"
                                data-testid="login-email-input"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="tu@esempio.it"
                                required
                                className="h-12 bg-card border-border/60"
                            />
                        </div>
                        <div className="space-y-2">
                            <Label htmlFor="password" className="text-xs uppercase tracking-widest text-muted-foreground">
                                Password
                            </Label>
                            <Input
                                id="password"
                                data-testid="login-password-input"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="La tua password"
                                required
                                className="h-12 bg-card border-border/60"
                            />
                        </div>
                        {err && (
                            <div
                                data-testid="login-error"
                                className="text-sm text-destructive bg-destructive/10 border border-destructive/30 rounded-lg px-3 py-2"
                            >
                                {err}
                            </div>
                        )}
                        <Button
                            data-testid="login-form-submit-button"
                            type="submit"
                            disabled={loading}
                            className="w-full h-12 text-sm font-semibold uppercase tracking-widest press"
                        >
                            {loading ? "Accesso in corso…" : "Entra"}
                        </Button>
                    </form>

                    <div className="mt-8 rounded-xl hairline bg-card/40 p-4">
                        <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground flex items-center gap-2 mb-3">
                            <SoccerBall size={14} weight="fill" /> Account demo
                        </div>
                        <div className="grid grid-cols-2 gap-2 text-xs">
                            <button
                                data-testid="demo-admin"
                                type="button"
                                onClick={() => demo("mauronet.rm@gmail.com", "Admin123!")}
                                className="rounded-lg border border-border/60 hover:border-primary/60 px-2 py-2 text-left press"
                            >
                                <div className="font-semibold">Admin</div>
                                <div className="text-muted-foreground truncate">mauronet.rm@…</div>
                            </button>
                            <button
                                data-testid="demo-coach"
                                type="button"
                                onClick={() => demo("allenatore@calcioclub.it", "Coach123!")}
                                className="rounded-lg border border-border/60 hover:border-primary/60 px-2 py-2 text-left press"
                            >
                                <div className="font-semibold">Allenatore</div>
                                <div className="text-muted-foreground truncate">allenatore@…</div>
                            </button>
                            <button
                                data-testid="demo-player"
                                type="button"
                                onClick={() => demo("giocatore@calcioclub.it", "Player123!")}
                                className="rounded-lg border border-border/60 hover:border-primary/60 px-2 py-2 text-left press"
                            >
                                <div className="font-semibold">Giocatore</div>
                                <div className="text-muted-foreground truncate">giocatore@…</div>
                            </button>
                            <button
                                data-testid="demo-parent"
                                type="button"
                                onClick={() => demo("genitore@calcioclub.it", "Parent123!")}
                                className="rounded-lg border border-border/60 hover:border-primary/60 px-2 py-2 text-left press"
                            >
                                <div className="font-semibold">Genitore</div>
                                <div className="text-muted-foreground truncate">genitore@…</div>
                            </button>
                        </div>
                    </div>

                    <div className="mt-6 text-sm text-muted-foreground text-center">
                        Non hai un account?{" "}
                        <Link to="/register" data-testid="register-link" className="text-primary press">
                            Registrati
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
